import Numeral from "../../../components/numeral/Numeral";
import { Tertiary } from "../../../components/buttons/Tertiary";
import { Fragment, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { v4 as uuid } from "uuid";
import { validateSessionAndJwtToken } from "../../../utils/validateTokenSession";
import { AcciValPage } from "./AcciValPage";
import { ToggleApiPaymentsService } from "../../../services/toggle_api_payments/toggle_api_payments.service";
import { AwaitPaymentModal } from "../../../components/modals/ModalCobreAwaitPayment";
import { FeaturesMethodPage } from "./features";
import { environment } from "../../../configs/variables";
import { HttpRequest } from "../../../services/httpRequest";
import { returnToSignin } from "../../../utils/returnToSign";
import { DashboardMyCredit } from "../../../components/backgrounds/DashboardMyCredit";
import { useCredit } from "../../../context/creditContext";
import { PrimaryMobile } from "../../../components/buttons/mobile/Primary";
import { SuccessAlert } from "../../../components/alerts/successAlert";
import { ErrorAlert } from "../../../components/alerts/errorAlert";
import { SkeletonMethodsPage } from "./components/skeleton_methods_page";
import { WompiHelper } from "./helpers/wompi-helper";
import { ModalWompiButton } from "../../../components/modals/ModalWompiButton";
import { WompiCheckout } from "./components/wompi_checkout";
import { useCreditPaymentIDB } from "../../../hooks/use-credit-payment";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const apiPaymentsDefault = "ACCIVAL";
const wompiHelper = new WompiHelper();

export function MethodsPage() {
  const { disclosures, creditInfo, due } = useCredit();
  const {
    getCreditPayment,
    ensureCreditPaymentExists,
  } = useCreditPaymentIDB();
  const navigate = useNavigate();
  const location = useLocation();

  const dataFromLocation = location.state?.data;

  const [isLoading, setIsLoading] = useState(true);
  const [features, setFeatures] = useState([]);
  const [apiPayments, setApiPayments] = useState(apiPaymentsDefault);
  const [showModalAwaitPayment, setShowModalAwaitPayment] = useState(false);
  const [returnAccivalPage, setReturnAccivalPage] = useState(false);
  const [modalMessagetitle, setModalMessagetitle] = useState(
    "Estamos redirigiendo hacia la pasarela de pago ..."
  );
  const [globalAmount, setGlobalAmount] = useState("");
  const [concatExtendPayData, setConcatExtendPayData] = useState("");
  const [viewalert, setViewalert] = useState(false);
  const [messsageAlert, setMessageAlert] = useState("");
  const [isOpenSuccess, setIsOpenSuccess] = useState(false);
  const [isOpenError, setIsOpenError] = useState(false);
  const [wompiParams, setWompiParams] = useState({
    reference: "",
    signature_integrity: "",
    amountInCents: 0,
  });
  const [showWompiButton, setShowWompiButton] = useState(false);
  const [fullName, setFullName] = useState("");
  const [creditId] = useState(localStorage.getItem('credit_id'));

  const handleClearStateAlert = () => {
    setViewalert(false);
    setMessageAlert("");
    setIsOpenSuccess(false);
    setIsOpenError(false);
  };

  let randomDate = "01/01/1992";

  const loadTogglePayment = async () => {
    try {
      const data = await ToggleApiPaymentsService.getData();
      return data.message.data;
    } catch (error) {
      console.log(error);
    }
  };

  const loadInfoUser = async () => {
    try {
      const data = await HttpRequest.getInfoUser(localStorage.getItem("doc"));
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  };

  const toggleShowModal = () => {
    setShowModalAwaitPayment(!showModalAwaitPayment);
  };

  const loadInfo = async () => {
    let info = await loadInfoUser();
    return info;
  };

  const resolvePersistedData = async (creditId, dataFromLocation) => {
    // 1) Si viene data desde navegación → la guardamos/actualizamos
    if (dataFromLocation) {
      return await ensureCreditPaymentExists({
        id: creditId,
        amount: dataFromLocation.extendPlazo
          ? String(dataFromLocation.totalSinCapital)
          : String(dataFromLocation.amount),
        hasExtend: dataFromLocation.extendPlazo,
        dateExtend: dataFromLocation.dateExtend,
      });
    }

    // 2) Si NO hay data en location (recarga) → intentamos recuperar de IndexedDB
    const stored = await getCreditPayment(creditId);
    if (!stored) {
      throw new Error("No hay datos de crédito en IndexedDB");
    }

    return stored;
  };

  const handleClickBtnCobre = async () => {
    try {
      toggleShowModal();
      handleClearStateAlert();
      setReturnAccivalPage(false);

      if (apiPayments === 'WOMPI') {
        try {
          await handleBusinessLogicWompi();
          return;
        } catch (error) {
          console.log(`Error al intentar pagar con Wompi: ${error}`);
          setReturnAccivalPage(true);
          return;
        }
      } else {
        setReturnAccivalPage(true);
        return;
      }
    } catch (error) {
      console.log(error);
      setModalMessagetitle("");
      setReturnAccivalPage(true);
      return;
    }
  };

  const handleBusinessLogicWompi = async () => {
    try {
      const amountInCents = wompiHelper.convertAmountToCents(globalAmount);
      const creditPaymentStored = await getCreditPayment(creditId);

      let payload = {
        credit_id: localStorage.getItem("credit_id"),
        documento: localStorage.getItem("doc"),
        amountInCents: amountInCents,
        hasNovation: creditPaymentStored?.hasExtend,
        novationDate: creditPaymentStored?.dateExtend
      };

      let response = await wompiHelper.generateCheckout(payload);

      if (response.error) {
        throw response.message;
      }

      let reference = response.reference;
      let signature_integrity = response.signature_integrity;
      setWompiParams({
        reference,
        signature_integrity,
        amountInCents: amountInCents,
        fullName: fullName,
        email: localStorage.getItem("email"),
        phone: localStorage.getItem("phone"),
        documento: localStorage.getItem("doc"),
      });
      setShowModalAwaitPayment(false);
      setShowWompiButton(true);
      return;
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    const validSessionAndTokenJwt = async () => {
      try {
        return await validateSessionAndJwtToken();
      } catch {
        return false;
      }
    };

    const loadTogglePayments = async () => {
      try {
        return await loadTogglePayment();
      } catch (error) {
        console.log(error);
        return [];
      }
    };

    (async () => {
      try {
        const isValidToken = await validSessionAndTokenJwt();

        if (!isValidToken) {
          return returnToSignin(navigate);
        }

        const creditId = localStorage.getItem("credit_id");

        // ---- 1) Cargar info del usuario ----
        const info = await loadInfo();
        const fullName = `${info?.firstname} ${info?.firstlastname}`;
        setFullName(fullName);

        // ---- 2) Resolver datos (location → IndexedDB → fallback) ----
        let storedItem;
        try {
          storedItem = await resolvePersistedData(creditId, dataFromLocation);
        } catch (error) {
          console.error(error);
          return navigate("/pagar");
        }

        // ---- 3) Definir monto final ----
        let _amount = dataFromLocation
          ? dataFromLocation.extendPlazo === true
            ? String(dataFromLocation.totalSinCapital)
            : String(dataFromLocation.amount)
          : storedItem.amount; // <-- aquí es donde funciona al recargar

        if (!_amount || _amount === "undefined") {
          _amount = storedItem.amount;
          environment !== "PROD" &&
            console.log("amount actualizado desde IndexedDB", _amount);
        }

        setGlobalAmount(_amount);

        // ---- 4) Reconstruir concatExtendPayData ----
        const hasExtend =
          dataFromLocation?.extendPlazo ?? storedItem.hasExtend;

        if (hasExtend !== undefined) {
          const dateExtend =
            dataFromLocation?.dateExtend ?? randomDate;

          setConcatExtendPayData(
            `${hasExtend};${dateExtend};${localStorage.getItem("doc")}`
          );
        }

        // ---- 5) Features y toggle de pagos ----
        setFeatures(
          FeaturesMethodPage({ extendPlazo: hasExtend })
        );

        const toggleApiPayments = await loadTogglePayments();
        const _apiPayments = toggleApiPayments[0];

        if ("apiPayments" in _apiPayments) {
          setApiPayments(_apiPayments.apiPayments);
        }

        setIsLoading(false);
      } catch (e) {
        console.log(e);
        returnToSignin(navigate);
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  if (isLoading) {
    return (
      <SkeletonMethodsPage />
    );
  }

  return (
    <Fragment>
      {viewalert && (
        <>
          <SuccessAlert
            isOpen={isOpenSuccess}
            message={messsageAlert}
          ></SuccessAlert>
          <ErrorAlert isOpen={isOpenError} message={messsageAlert}></ErrorAlert>
        </>
      )}
      <DashboardMyCredit
        current3={true}
        name={dataFromLocation?.name}
        current={"2"}
        balance={dataFromLocation?.amount}
        title={"¿Como quieres pagar?"}
        disclosures={disclosures}
        creditInfo={creditInfo}
        due={due}
        main={
          <div className="pb-32 md:pb-0 px-0 md:px-8 lg:px-0">
            <>
              {apiPayments && (apiPayments === "COBRE" || apiPayments === "COBRE2" || apiPayments === "WOMPI") ? (
                <div className="relative py-10 grid grid-cols-8 gap-4">
                  {features.map((feature, index) => (
                    <div
                      key={index}
                      className={
                        "col-span-8 xl:col-span-4 grid content-between h-full rounded-3xl transition shadow-lg py-4 bg-white"
                      }
                    >
                      <div
                        key={index}
                        className={
                          feature.classTitle || "flex justify-between pb-6"
                        }
                      >
                        <div className="flex text-lg font-bold mx-auto pt-2">
                          <img
                            className="w-8 h-auto mr-2"
                            src={feature.img}
                            alt="medios-de-pago-galilea"
                          />
                          <h3 className="">{feature.title}</h3>
                        </div>
                      </div>

                      <div className="px-4 pt-6">
                        {feature.details.map((detail, i) => (
                          <div key={detail.id}>
                            <div className="flex pb-4">
                              <detail.icon
                                className="w-6 h-auto mr-4"
                                aria-hidden="true"
                              />
                              <div>
                                {detail.description}{" "}
                                <Numeral
                                  format={"$0,0"}
                                  value={detail.number}
                                />{" "}
                              </div>
                            </div>
                            <div
                              key={detail.id}
                              className="text-xl font-bold mx-auto uppercase text-center"
                            >
                              <span
                                className={classNames(
                                  detail.alert === "Vigente"
                                    ? "text-white bg-purple px-4 py-2 rounded-md"
                                    : detail.alert === "Al día"
                                      ? "text-white bg-tdark px-4 py-2 rounded-md"
                                      : detail.alert === "En mora"
                                        ? "text-white bg-red px-4 py-2 rounded-md"
                                        : "text-tdark font-medium"
                                )}
                              >
                                {detail.alert}
                              </span>
                            </div>
                          </div>
                        ))}
                        {feature.wompiPay ? (
                          <div className="flex pr-4 justify-end">
                            <PrimaryMobile
                              text={"Pagar ahora"}
                              onClick={handleClickBtnCobre}
                            />
                          </div>
                        ) : (
                          <a
                            href={feature.href}
                            state={{
                              data: {
                                amount: globalAmount,
                                name: dataFromLocation?.name,
                                extendPlazo: dataFromLocation?.extendPlazo,
                              },
                            }}
                          >
                            <div className="flex pr-4 justify-end">
                              <PrimaryMobile text={"Pagar ahora"} />
                            </div>
                          </a>
                        )}
                      </div>
                    </div>
                  ))}

                  {showWompiButton && (
                    <ModalWompiButton
                      isOpen={showWompiButton}
                      title={"Pagar ahora con Wompi"}
                      messageTitle={""}
                      ContentAction={
                        <WompiCheckout
                          amountInCents={wompiParams.amountInCents}
                          reference={wompiParams.reference}
                          signature={wompiParams.signature_integrity}
                          email={wompiParams.email}
                          fullName={wompiParams.fullName}
                          phone={wompiParams.phone}
                          documento={wompiParams.documento}
                        />
                      }
                      showContentAction={true}
                      onHide={() => setShowWompiButton(false)}
                    ></ModalWompiButton>
                  )}

                  {showModalAwaitPayment && (
                    <AwaitPaymentModal
                      isOpen={showModalAwaitPayment}
                      title={"Espere un momento."}
                      messageTitle={modalMessagetitle}
                      ContentAction={
                        <AcciValPage
                          payload={{
                            orderNumber: uuid(),
                            amount: globalAmount,
                            email: localStorage.getItem("email"),
                            phone: localStorage.getItem("phone"),
                            firstname: dataFromLocation?.name,
                            lastname: dataFromLocation?.lastname,
                            doctype: "4",
                            documento: localStorage.getItem("doc"),
                            orderDescription: `Pago de crédito #${localStorage.getItem(
                              "credit_id"
                            )}`,
                            additionalData: btoa(concatExtendPayData),
                          }}
                        />
                      }
                      showContentAction={returnAccivalPage}
                      onHide={() => setShowModalAwaitPayment(false)}
                    ></AwaitPaymentModal>
                  )}
                </div>
              ) : (
                <div className="relative py-10 grid grid-cols-8 gap-4">
                  {features.map((feature, index) => (
                    <a
                      target={feature.wompiPay ? "_blank" : "_self"}
                      rel={feature.wompiPay ? "noopener noreferrer" : undefined}
                      key={index}
                      href={feature.href}
                      className={
                        "col-span-8 border-2 border-purple xl:col-span-4 grid content-between h-full rounded-3xl transition shadow-lg py-4 bg-white"
                      }
                    >
                      <div
                        key={index}
                        className={
                          feature.classTitle || "flex justify-between pb-6"
                        }
                      >
                        <div className="flex text-lg font-bold mx-auto pt-2">
                          <img
                            className="w-8 h-auto mr-2"
                            src={feature.img}
                            alt="medios-de-pago-galilea"
                          />
                          <h3 className="">{feature.title}</h3>
                        </div>
                      </div>
                      <div className="px-4 pt-6">
                        {feature.details.map((detail) => (
                          <div key={detail.id}>
                            <div className="flex pb-4">
                              <detail.icon
                                className="w-6 h-auto mr-4"
                                aria-hidden="true"
                              />
                              <div>
                                {detail.description}{" "}
                                <Numeral
                                  format={"$0,0"}
                                  value={detail.number}
                                />{" "}
                              </div>
                            </div>
                            <div
                              key={detail.id}
                              className="text-xl font-bold mx-auto uppercase text-center"
                            >
                              <span
                                className={classNames(
                                  detail.alert === "Vigente"
                                    ? "text-white bg-purple px-4 py-2 rounded-md"
                                    : detail.alert === "Al día"
                                      ? "text-white bg-tdark px-4 py-2 rounded-md"
                                      : detail.alert === "En mora"
                                        ? "text-white bg-red px-4 py-2 rounded-md"
                                        : "text-tdark font-medium"
                                )}
                              >
                                {detail.alert}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="flex pr-4 justify-end">
                        {feature.wompiPay ? (
                          <AcciValPage
                            payload={{
                              orderNumber: uuid(),
                              amount:
                                dataFromLocation?.extendPlazo === true
                                  ? dataFromLocation?.totalSinCapital
                                  : dataFromLocation?.amount,
                              email: localStorage.getItem("email"),
                              phone: localStorage.getItem("phone"),
                              firstname: dataFromLocation?.name,
                              lastname: dataFromLocation?.lastname,
                              doctype: "4",
                              documento: localStorage.getItem("doc"),
                              orderDescription: `Pago de crédito #${localStorage.getItem(
                                "credit_id"
                              )}`,
                              additionalData: btoa(concatExtendPayData),
                            }}
                          />
                        ) : (
                          <Tertiary text={"Pagar ahora"} />
                        )}
                      </div>
                    </a>
                  ))}
                </div>
              )}
            </>
          </div>
        }
      />
    </Fragment>
  );
}